import type {
  ConceptSortField,
  ConceptSortOrder,
  ConceptStockRow,
} from "./ConceptType";

function dragonScoreBucket(fundamentalScore: number | null | undefined): number {
  if (fundamentalScore == null || !Number.isFinite(fundamentalScore)) {
    return Number.MIN_SAFE_INTEGER;
  }
  const forBucket = Math.min(fundamentalScore, 99);
  return Math.floor(forBucket / 10);
}

function compareNullableNumber(
  a: number | null | undefined,
  b: number | null | undefined,
  asc: boolean
): number {
  const aOk = a != null && Number.isFinite(a);
  const bOk = b != null && Number.isFinite(b);
  if (!aOk && !bOk) {
    return 0;
  }
  if (!aOk) {
    return asc ? 1 : -1;
  }
  if (!bOk) {
    return asc ? -1 : 1;
  }
  return asc ? a - b : b - a;
}

/** 龙头排序：按基本面分档（90–100 同档），档内按 positionScore 降序 */
function compareDragonScore(a: ConceptStockRow, b: ConceptStockRow): number {
  const bucketA = dragonScoreBucket(a.fundamentalScore);
  const bucketB = dragonScoreBucket(b.fundamentalScore);
  const bucketCmp = bucketB - bucketA;
  if (bucketCmp !== 0) {
    return bucketCmp;
  }
  return compareNullableNumber(a.positionScore, b.positionScore, false);
}

function fieldValue(row: ConceptStockRow, field: ConceptSortField): number | null | undefined {
  return row[field];
}

export function sortConceptStockRows(
  rows: ConceptStockRow[],
  field: ConceptSortField | "dragon",
  order: ConceptSortOrder
): ConceptStockRow[] {
  const asc = order === "asc";
  const copy = [...rows];
  if (field === "dragon") {
    copy.sort(compareDragonScore);
    return copy;
  }
  copy.sort((a, b) => compareNullableNumber(fieldValue(a, field), fieldValue(b, field), asc));
  return copy;
}
